import { defineStore } from "pinia";
import { CR_API_KEY } from "../models/constants-general";
// import {SettingsTotal, UserprofileApi} from "../cr-api-client/src/index"
import {SettingsTotal, UserprofileApi, ConfigApi} from "../cr-userprofile-api-client/src/index"

const baseUrl = () => `${window.CLEVERROUTE_HOST || '.'}/api/v1`

export const useUserprofileStore = defineStore({
  id: "userprofile",
  state: () => ({
    routingsSettings: [],
    userMetricsSettings: [],
    tickets: [],
    vehiclesSpec: [],
    userProfileSettings: {}
  }),
  getters: {
    /**
     * return ORS api key of current index
     * @param {*} state 
     * @returns 
     */
    getTransportSettings: (state) => {
      return state.transportSettings;
    },
  },
  actions: {

    /**
     * fetch transport settings of user
     */
    fetchTransportSettings(userId) {
      new UserprofileApi().getUserSettings(userId, (error, data, response) => {
        const settingsTotalObj = SettingsTotal.constructFromObject(data);
        this.routingsSettings = settingsTotalObj.routingsSettings;
        this.userMetricsSettings = settingsTotalObj.userMetricsSettings;
        this.userProfileSettings = settingsTotalObj.userProfileSettings;
        this.vehiclesSpec = settingsTotalObj.vehiclesSpec;
        this.tickets = settingsTotalObj.tickets;
      });
    
    },
    /**
     * setting the status of the loading status of the route search
     * @param {*} status status to set to like true or false
     */
    setPageLoading(status) {
      this.pageLoading = status;
    },
    fetchTransportGroups() {
      const api =
        `${baseUrl()}/config/transportGroupsBuilt`;

      fetch(api, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'x-api-key': CR_API_KEY

        }
      })
        .then((response) => response.json())
        .then(({ data }) => {
          if (data.hasOwnProperty("transportgroupsBuilt")) {
            this.transportGroupsBuilt = data.transportgroupsBuilt;
          }

        })
        .catch((error) => console.log(error));
    },
    /**
 * setting the status of search request
 * @param {*} status status to set to like true or false
 */
    setSearchRunning(status) {
      this.searchRunning = status;
    },
    /**
     * set keys only if it is defined and is an array
     * @param {*} keys 
     */
    setOrsApiKeys(keys) {
      if (keys && keys instanceof Array) {
        this.orsApiKeys = keys;
      }
    },
    setFrontendConfig(frontendConfig) {
      // only if sortByValue is passed set it, otherwise use the default value
      if (frontendConfig.metricToSortRoutesBy) {
        this.metricToSortRoutesBy = frontendConfig.metricToSortRoutesBy;
      }
    },
    setMetricToSortRoutesBy(val) {
      // only if sortByValue is passed set it, otherwise use the default value
      if (val) {
        this.metricToSortRoutesBy = val;
      }
    },
    setAllowPastDate(val) {
      if (val) {
        this.allowPastDate = val;
      }
    },
    setMetricToJourneyThereTimeOrientation(val) {
      if (val) {
        this.metricToJourneyThereTimeOrientation = val;
      }
    }
  },
});
